import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'

import { once, isServer } from '@vue-storefront/core/helpers'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { Logger } from '@vue-storefront/core/lib/logger'

import { googleTagManagerModule } from './store'
import { isEnabled, getGtmSource } from './helpers';
import { afterRegistration } from './hooks/afterRegistration'
import { setDefaultConsent } from 'src/modules/gdpr-cookie-setup/helpers'

export const KEY = 'google-tag-manager'

export const GoogleTagManagerModule: StorefrontModule = function ({ store, router, appConfig }) {
  setDefaultConsent()

  if (isEnabled(appConfig.googleTagManager.id)) {
    once('__VUE_EXTEND_GTM__', () => {
      Vue.use(VueGtm, {
        enabled: true,
        id: appConfig.googleTagManager.id,
        source: getGtmSource(),
        debug: appConfig.googleTagManager.debug,
        vueRouter: router
      })
    })

    if (appConfig.analytics.id) {
      once('__VUE_EXTEND_GTAG__', () => {
        Vue.use(VueGtag, {
          pageTrackerEnabled: false,
          config: {
            id: appConfig.analytics.id
          }
        }, null);
      })
    }
  } else {
    Logger.warn('Google Tag Manager extensions is not working. Ensure Google Tag Manager container ID is defined in config', 'GTM')()
  }

  store.registerModule(KEY, googleTagManagerModule)

  afterRegistration(appConfig, store)
}
